module.exports = __webpack_public_path__ + "static/img/hcp-seg-brintellix-1.8ba4fe78.png";